<template>
  <div class="news-box">
    <h4 class="title">{{ newsDetail.title }}</h4>
    <p class="time">{{ newsDetail.createdAtForRead }}</p>
    <article class="content" v-html="content"></article>
    <p class="link-box">
      <a v-if="0 < newsDetail.preNumberId" :href="'./' + newsDetail.preNumberId + '.html'">上一篇</a>
      <a v-if="0 < newsDetail.nextNumberId" :href="'./' + newsDetail.nextNumberId + '.html'">下一篇</a>
    </p>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    // 服务器端渲染，预加载资讯详情数据
    asyncData ({ store, route }) {
      return store.dispatch('getNewsDetail', route.params.id)
    },
    computed: {
      ...mapGetters({
        newsDetail: 'newsDetail'
      }),
      content () {
        let res = '';

        this.newsDetail.content.forEach(item => {
          if (item.contentType === 'PICTURE') {
            res += `<img style="width: 100%;margin-bottom: 10px;" src='${ item.content }' />`
          } else if (item.contentType === 'TEXT') {
            res += `<p>${ item.content }</p>`
          }
        });

        return res
      }
    }
  }
</script>
<style lang="scss" scoped>
  .news-box {
    padding: 10px;
    background-color: #FFF;
    line-height: 22px;
    .title {
      font-size: 16px;
      line-height: 24px;
    }
    .time {
      color: #777;
      margin-bottom: 10px;
    }
  }
  .link-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .link-box > a {
    color: blue
  }
</style>



// WEBPACK FOOTER //
// src/views/Article.vue